import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Input, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { clone, cloneDeep } from 'lodash';
import { stat } from 'src/app/admin/layout/header/header.component';
import { QuestionBank } from 'src/app/misc/data/questionBank';
import { DataService } from 'src/app/services/data.service';
import { GlobalConstants, ImageTypes } from 'src/app/services/global-constants';
import { ImageuploadService } from 'src/app/services/imageupload.service';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { MessageService, TreeNode } from 'primeng/api';


@Component({
  selector: 'app-questions-edit',
  templateUrl: './questions-edit.component.html',
  styleUrls: ['./questions-edit.component.scss', '../add-question.component.scss']
})
export class QuestionsEditComponent {

  @Input() question: any;
  @Input() questionIndex: any;
  @Input() isAssessment: boolean = false;
  @Input() isTopic: boolean = false;
  @Input() isImpactSurvey: boolean = false;
  @Input() survey: any = {};
  //Conditional Questions attributes
  @Input() conditionalQuestions: any[] = [];
  @Input() linkedQuestions: any[] = [];
  @Input() getConditionalOptions: any
  @Input() removeQuestion: any;
  @Input() disableConditionalOptions: any;
  @Input() disableLinkedOptions: any;
  @Input() disabled: boolean = false;
  @Input() editingIndex: number = -1;
  @Input() fromTraining: boolean = false;
  @Input() isConditional: boolean = false;
  @Input() isLinked: boolean = false;
  @Input() UserExternalFields: boolean = false;
  @Input() difficultyLevels: any[] = [];
  /** OU tree options for OU_TREE_DROPDOWN (from parent add-question getTreeData) - not shown on creation */
  @Input() ouTreeOptions: any[] = [];
  /** Available OU tree tags for OU_TREE_DROPDOWN (which tags to show on attempt side) */
  @Input() availableOuTreeTags: Array<{ label: string; value: string }> = [
    { label: 'Ministries/Entities', value: 'Ministries/Entities' },
    { label: 'Organisational Units', value: 'Organisational Units' },
    { label: 'Branches', value: 'Branches' },
    { label: 'Organisational Structure', value: 'Organisational Structure' },
  ];
  @Output() saveProgress = new EventEmitter<any>();

  selectedTopic: any;

  toggleSelection(event: any) {
    //todo
  }

  // Default difficulty levels if not provided by parent
  get defaultDifficultyLevels() {
    return [
      { label: this.translate("Unidentified"), value: "unidentified" },
      { label: this.translate("Easy"), value: "easy" }, 
      { label: this.translate("Medium"), value: "medium" }, 
      { label: this.translate("Hard"), value: "hard" }
    ];
  }

  // Use input difficulty levels if provided, otherwise use default
  get difficultyLevelsToUse() {
    return this.difficultyLevels && this.difficultyLevels.length > 0 
      ? this.difficultyLevels 
      : this.defaultDifficultyLevels;
  }

  /** OU tree tag options with translated labels for display (no English on frontend) */
  get availableOuTreeTagsToUse(): Array<{ label: string; value: string }> {
    const raw = this.availableOuTreeTags?.length
      ? this.availableOuTreeTags
      : [
          { label: 'Ministries/Entities', value: 'Ministries/Entities' },
          { label: 'Organisational Units', value: 'Organisational Units' },
          { label: 'Branches', value: 'Branches' },
          { label: 'Organisational Structure', value: 'Organisational Structure' },
        ];
    return raw.map((o: { label: string; value: string }) => ({ label: this.translate(o.value), value: o.value }));
  }

  staticFileUrl = GlobalConstants.staticFilesURL;
  fileInput!: HTMLInputElement;
  messages: any[] = [];
  questionBank: any = QuestionBank;
  additionIndex: number = -1;
  defaultScore: number = 10;
translator: TranslatorPipe = new TranslatorPipe()

  days: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
  years: number[] = Array.from({ length: 100 }, (_, i) => new Date().getFullYear() - i);
  showSelectServiceModal: boolean = false;
  currentQuestionService: any;
  locationOrigin: string = window.location.origin;

  constructor(
    private fileService: ImageuploadService,
    private router: Router,
    private messageService: MessageService,
  ) {    
  }

  ngOnChanges(changes: SimpleChanges): void {
    const q = changes['question']?.currentValue;
    if (q?.type === 'OU_TREE_DROPDOWN' && q.meta) {
      if (!Array.isArray(q.meta.ouTreeTags)) {
        q.meta.ouTreeTags = [
          'Ministries/Entities',
          'Organisational Units',
          'Branches',
          'Organisational Structure',
        ];
      }
      if (q.meta.description === undefined || q.meta.description === null) {
        q.meta.description = '';
      }
    }
  }

  getIconClass(icon: string) {
    if (icon.includes('fa')) {
      return 'fa ' + icon;
    } else {
      return 'pi ' + icon;
    }
  }

  print(event: any) {
    //console.log('PRINT EVENT', event);
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode !== 46 && charCode !== 45 && charCode > 31 && (charCode < 48 || charCode > 57)) ||
        (event.target.value.includes('.') && charCode === 46)) {
      return false;
    }
    return true;
  }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  async onQuestionImageSelect(event: any, field: any) {
    if (this.disabled) {
      return;
    }
    try {
      const file: File = event.target.files[0];
      if (file) {
        const res = await this.fileService.uploadImage(file, ImageTypes.survey);
        if (res.error) {
          this.messageService.add(
            { severity: 'error', summary: this.translate('error'), detail: this.translate(res.msg) },
          );
        } else {
          field.url = res.data;
          this.saveProgress.emit()
        }
      }
    } catch (e) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e },
      ]
    }
  }

  //Input field methods
  addRowInTextInput(question: any, index: number) {
    if (this.disabled) {
      return;
    }
    question.meta.fields.push({ label: '', placeholder: 'خيار ' + (question.meta.fields.length + 1), valueLabel: question.meta.fields[0].valueLabel })
  }

  setCurrentEditQuestion(i: number) {
  }

  getConditionalQuestions(){
  }

  private oldLabel: string = '';

  storeOldValue(field: any) {
    this.oldLabel = field.label; // Store the old value when input gets focus
  }


onLabelChange(field: any, newValue: string) {
  console.log("The field has been changed:", this.oldLabel);
  console.log("What was the meta:", this.question.meta.correct);

  // If this field's value was previously selected as correct, update it
  if (this.question.meta.correct === this.oldLabel) {
    this.question.meta.correct = newValue;
    console.log("What has meta become:", newValue);
  }

  // Update field.label and oldLabel
  field.label = newValue;
  this.oldLabel = newValue; // Keep oldLabel in sync for future changes
}

  removeRowInTextInput(question: any, index: number, questionIndex: number) {

    //console.log(question, index,questionIndex)
    if (this.disabled) {
      return;
    }
    if (question.meta.fields.length == 1) {
      if (this.removeQuestion !== null) {
        this.removeQuestion(questionIndex, this.UserExternalFields);
      }
    } else {
      question.meta.fields.splice(index, 1);

    }
    this.survey = this.survey;
  }

  selectImage(ref: HTMLInputElement) {
    if (this.disabled) {
      return;
    }
    ref.disabled = false;
    ref.click();
    ref.disabled = true;
  }

  addImageToSelected(question: any, label: string) {
    if (this.disabled) {
      return;
    }
    if (question.meta.correct.includes(label)) {
      let index = question.meta.correct.indexOf(label);
      question.meta.correct.splice(index, 1);
    } else {
      question.meta.correct.push(label);
    }
  }

  getRankDDValues(question: any): string[] {
    let values: string[] = [];

    for (let i = 1; i < question.meta.fields.length + 1; i++) {
      values.push(i.toString());
    }

    return values;
  }

  addFieldWithOrder(question: any) {
    if (this.disabled) {
      return;
    }
    question.meta.fields.push({ label: '', placeholder: "خيار " + (question.meta.fields.length + 1), order: (question.meta.fields.length + 1) })
  }

  updateCalendarDate(question: any) {
    if (this.disabled) {
      return;
    }
    question.meta.value = new Date();
  }

  updateColumn(question: any, event: any, index: number) {
    if (this.disabled) {
      return;
    }
    question.meta.columnsPlaceholder.splice(index, 1, event.target.value);
  }

  addColumn(question: any) {
    if (this.disabled) {
      return;
    }
    question.meta.columnsPlaceholder.push('Column ' + (question.meta.columnsPlaceholder.length + 1))
  }

  addRow(question: any, valueType: any) {
    if (this.disabled) {
      return;
    }
    question.meta.fields.push({
      field: { label: '', placeholder: "خيار " + (question.meta.fields.length + 1), value: valueType },
    });
  }

  removeRow(question: any, rowIndex: number) {
    if (this.disabled) {
      return;
    }
    question.meta.fields.splice(rowIndex, 1);
  }
  
  removeColumn(question: any, columnIndex: number) {
    if (this.disabled) {
      return;
    }
    question.meta.columnsPlaceholder.splice(columnIndex, 1);
    question.meta.columns.splice(columnIndex, 1);
  }

  resetCorrect(question: any, label: any){
    if (label.trim == '')
    {
      question.meta.correct = ' ';
    }
  }

  getDatePlaceholder(date: string) {
    if (date && typeof date === 'string') { 
      return date.split('T')[0];
    }
    return '';
  }

  openServiceModal(question:any)
  {
    this.showSelectServiceModal = true;
    this.currentQuestionService = question
  }

  setServiceLink(service: any) {
    if (service) {
      this.currentQuestionService.meta.QType = 'Service';
      this.currentQuestionService.meta.service = service.id;
      this.currentQuestionService.meta.servicelabel = service?.ministry.label
      this.currentQuestionService.meta.serviceIcon  = service?.ministry.icon
      this.currentQuestionService = null;
    }
    this.showSelectServiceModal = false;
  }

  launchUrl(url: string) {
    window.open(this.locationOrigin + '/data/' + url, '_blank');
  }

  canConditional(current: any): boolean {
    return this.survey.questions.some((question: any) => 
        question?.meta?.condition?.question?.questionCode == current.questionCode
    );
  }

  canLinked(current: any): boolean {
    return this.survey.questions.some((question: any) => 
        question?.meta?.linkedQ && question.meta.linkedQ?.questionCode == current.questionCode
    );
  }

  unlockQuestion(){
    this.disabled = false;
  }

  set selectedQuestion(value: any) {
    if (value !== null) {
      //console.log("Value",value)
      this.question.meta.condition.question = value;
    }
  }
  
  get selectedQuestion() {
    //console.log("this.question.meta.condition.question",this.question.meta.condition.question)
    return this.question.meta.condition.question;
  }

  set selectedLinkQuestion(value: any) {
    if (value !== null) {
      this.question.meta.linkedQ = value;
    }

    //console.log(this.question);
  }
  
  get selectedLinkQuestion() {
    return (this.question.meta.linkedQ != undefined) ? this.question.meta.linkedQ : null;
  }

  set selectedOption(value: any) {
    if (value !== null) {
      this.question.meta.condition.option = value;
    }
  }
  
  get selectedOption() {
    return this.question.meta.condition.option;
  }

  getPlaceholder(){
    if (this.question.meta.condition.question)
    {
      return this.question.meta.condition.question?.questionText;
    }
    else{
      return this.translate('Select Question')

    }
  }

  getLinkPlaceholder(){
    if (this.question.meta.linkedQ != undefined)
    {
      return (this.question.meta.linkedQ) ? this.question.meta.linkedQ?.questionText : this.translate('Select Question');
    }
    else{
      return this.translate('Select Question')

    }
  }

  showErrorCond(){
    this.messageService.add({ severity: 'error', summary: this.translate('error'), detail: this.translate('Disabled PLease Unlock to Edit') });
    return;
  }


  getHeader(question:any){

    if(question.questionText) return question.questionText;
    
    if(question.type === 'SINGLE_ROW_TEXT' || question.type === 'EMAIL_ADDRESS' || question.type === 'COMMENT_BOX') return question?.meta?.fields[0]?.label;




   return question.questionText ? question.questionText : question.meta.description ? question.meta.description : question.name
  }

  checkisImg(arg0: string | undefined): boolean {
    if (arg0) {
      return /\.(jpg|jpeg|png|gif|svg)/.test(arg0);
    }
    return false;
  }

}
